<template>
  <div class="imgBox min-w-1400">
    <div class="imgBox1 min-w-1400">
      <div class="img1 max-w-1400">
        <p class="imgItem1">Chính sách hoàn trả</p>
        <!-- <img :src="importedImg1" :alt="altText" class="imgItem1" /> -->
      </div>
    </div>
    <div class="imgBox2 min-w-1400">
      <div class="img2 max-w-1400">
        <!-- <h1>Cam kết bảo mật</h1> -->
        <!-- <div class="title-line"></div> -->
        <div class="textBox" style="white-space: pre-wrap">{{ text }}</div>
      </div>
    </div>
  </div>
</template>

<script>
// import importedImg1 from "@/page/passmorecompany/components/img/4_1.png";

export default {
  data() {
    return {
      altText: "protocolTitle",
      // importedImg1: importedImg1,
      text: `Nếu bạn đã mua sản phẩm từ Easylife nhưng không còn sử dụng hoặc muốn đổi sang sản phẩm khác do công ty cung cấp, vui lòng làm theo các bước dưới đây để xử lý hoàn lại tiền:

1. Đối với hàng hóa chưa giao:

Khách hàng liên hệ trực tiếp với nhân viên bán hàng mà họ làm việc cùng và đồng ý chuyển sang một sản phẩm khác.    Gửi lại báo giá cho khách hàng.

2. Đối với sản phẩm đã giao:

Đối với sản phẩm lỗi:

Khi nhận hàng, bạn có thể kiểm tra xem hàng có đúng sản phẩm không và có thỏa thuận mua hàng với công ty chúng tôi không? Nếu phát hiện sản phẩm bị lỗi, Công ty có thể yêu cầu đổi hàng và Công ty sẽ chịu mọi chi phí vận chuyển.

Nếu sản phẩm bị lỗi do lý do của khách hàng, công ty không chịu trách nhiệm đổi hàng. Nếu bạn muốn đổi sản phẩm, bạn sẽ phải trả thêm phí. Phí này tùy thuộc vào sản phẩm và thỏa thuận giữa khách hàng và nhân viên bán hàng.

Đối với sản phẩm không bị lỗi:

Khi sản phẩm đến tay khách hàng, khách hàng không thích sản phẩm và muốn đổi sang sản phẩm khác. Khách hàng phải tuân thủ những điều sau:

Sản phẩm vẫn còn trong hộp và tình trạng ban đầu.

Mọi chi phí phát sinh như chi phí vận chuyển...đều do khách hàng chi trả.

Quyết định của Easylife là quyết định cuối cùng.`,
    };
  },
  created() {
    this.gotoTop();
  },
  methods: {
    gotoTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
  },
};
</script>

<style scoped>
.imgBox {
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
}

.imgBox1 {
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: 1400px;
  background-color: "";
}

.imgBox2 {
  display: flex;
  justify-content: center;
  max-width: 1400px;
  padding-top: 40px;
  padding-bottom: 20px;
  height: 3700px;
  background-color: #ffffff;
  border-radius: 32px;
  margin: -140px auto 150px;
}

.imgBox3 {
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: 1400px;
  background-color: "";
}

img {
  display: block;
}

.img1 {
  overflow: hidden;
  width: 100%;
}

.img2,
.img4 {
  overflow: hidden;
}

.img3 {
  width: 100%;
  overflow: hidden;
  margin-left: 0;
  margin-right: 0;
}

.imgItem1 {
  width: 100%;
  margin-top: 0;
  margin-bottom: 0;
}

.imgItem2 {
  max-width: 100%;
}

.imgItem3 {
  width: 100%;
  overflow: hidden;
  margin-left: 0;
  margin-right: 0;
}

h1 {
  margin-top: 50px;
  margin-left: 490px;
  color: #3f4842;
  font-size: 40px;
  /* border-bottom: 5px solid #04358A; */
  display: inline-block;
}

.textBox {
  margin-top: 50px;
  margin-left: 100px;
  margin-right: 100px;
  font-size: 18px;
  color: #333333;
}

.imgBox2 {
  transform: scale(90%);
  /* transform: scale(80%); */
  margin: -150px auto 100px;
  height: 800px;
  /* box-shadow: 0 1px 4.8px 0px rgba(246, 102, 11, 0.25); */
  /* border: 2px solid #F6660B; */
}
.textBox {
  margin-top: 20px;
  margin-left: 50px;
  margin-right: 50px;
}
/* .imgBox2{
  border-radius: 0;
  border-top: 3px solid #7c2af8;
  border-left: 2px solid #e9e9e9;
  border-right: 2px solid #e9e9e9;
  border-bottom: 3px solid #c1c1c1;
} */
.title-line {
  width: 430px;
  /* background: url(./components/img/Group1.png); */
  /* background-repeat: no-repeat; */
  /* background-position: -150px 10px; */
  /* height: 50px; */
  /* border: 1px solid red; */
  border: 5px solid #0baf60;
  margin: 0 500px;
}

.img1 {
  /* background: radial-gradient(57.03% 57.03% at 50% 50%, #3C51A0 0%, #223479 100%); */
  height: 291px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.imgItem1 {
  color: #333333;
  font-family: "SF Pro Display";
  font-weight: 700;
  font-size: 52px;
  text-align: center;
}
</style>
